export const TARGET_SYSTEM = {
  LEGACY: "legacy",
  DMPS: "dmps",
  PMPS_COMPLETE: "pmpsc",
  PMPS_PAGE: "pmpsp",
  MIGRATION_ORION: "momc",
  MIGRATION_IPSO_DIRECT_MPS: "midmps",
  MIGRATION_IPSO_COMPLETE: "mimc",
  MIGRATION_IPSO_PAGE: "mimp",
  DAAS: "daas",
  MP_FLEX_RESELL: "mpflexr",
  MIGRATION_DAAS: "midaas",
  SELL_THROUGH: "daas-st",
  SELL_WITH: "daas-sw",
  BILL_THROUGH: "daas-bt",
  PMPS_SELL_THROUGH: "pmps-st",
  PMPS_SELL_WITH: "pmps-sw",
  PMPS_BILL_THROUGH: "pmps-bt",
  MIGRATION_SELL_THROUGH: "mist",
  MIGRATION_SELL_WITH: "misw",
  MIGRATION_BILL_THROUGH: "mibt",
  CHANNEL_DAAS: "cDaas",
  MIGRATION_CHANNEL_DAAS: "micd",
  MANAGED_COLLABORATION_SERVICES: "mcs-direct",
  MCS_SELL_THROUGH: "mcs-gsi-st",
  MCS_SELL_WITH: "mcs-gsi-sw",
  MCS_BILL_THROUGH: "mcs-gsi-bt",
  DIGITAL_SERVICE: "ds",
};

export const DAAS_TARGET_SYSTEMS = Object.freeze(["daas", "daas-st", "daas-sw", "daas-bt", "midaas", "mist", "misw", "mibt", "cDaas", "micd", "mcs-gsi-st", "mcs-gsi-sw", "mcs-gsi-bt", "mcs-direct", "ds"]);
export const GSI_DAAS_TARGET_SYSTEMS = Object.freeze(["daas-st", "daas-sw", "daas-bt", "mist", "misw", "mibt"]);
export const GSI_MCS_TARGET_SYSTEMS = Object.freeze(["mcs-gsi-st", "mcs-gsi-sw", "mcs-gsi-bt"]);
export const  MCS_TARGET_SYSTEMS = Object.freeze(['mcs-direct', 'mcs-gsi-st', 'mcs-gsi-bt', 'mcs-gsi-sw']);


export const PMPS_TARGET_SYSTEMS = Object.freeze(["pmpsc", "pmpsp", "mimc", "mimp", "mpflexr"]);
export const GSI_PMPS_TARGET_SYSTEMS = Object.freeze(["pmps-st", "pmps-sw", "pmps-bt"]);

export const GEO_REGIONS = Object.freeze({
  AMS: "AMS",
  EMEA: "EMEA",
  APJ: "APJ",
});

export const LATAM_COUNTRIES = [
  "MX",
  "AR",
  "CL",
  "CO",
  "PE",
  "CR",
  "PR",
];

export const CREDIT_BLOCK_REASON = {
  Z01: "Payment Term Block",
  Z02: "Credit Hold Block",
  Z03: "Overdue Open Items Block",
  Z04: "Credit Exposure Block",
};
